import { dispatch, PaymentStore, useSelector } from "@nf/common";
import { useSyncCompleted } from "hooks";
import { useEffect } from "react";

export const useDataPayment = () => {
  const isAuthProcessCompleted = useSyncCompleted();
  const {
    offers: {
      IsProcessing: areOffersLoading,
      Error: offersError,
      Initialized: offersInitialized,
      Completed: offersCompleted,
    },
  } = useSelector((state) => state.payment);

  const offers = useSelector((state) => state.payment.offers.Data?.offers);

  useEffect(() => {
    if (!offersInitialized && isAuthProcessCompleted) {
      dispatch(PaymentStore.Actions.getOffers());
    }
  }, [offersInitialized, isAuthProcessCompleted]);

  return {
    areOffersLoading,
    offersError,
    offers,
    offersInitialized,
    offersCompleted,
  };
};
